import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ea5fc72"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Add a new Data product", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Choose a Data product type: ", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["tabindex", "placeholder", "onUpdate:modelValue"]
const _hoisted_6 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_7 = ["tabindex"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "tags-container glossary" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "tags-container tags" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["tabindex", "onUpdate:modelValue"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_16 = ["for"]
const _hoisted_17 = ["name", "id", "accept", "onChange", "placeholder"]
const _hoisted_18 = { style: {"display":"flex","justify-content":"space-between","width":"100%","margin-top":"30px"} }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = _withModifiers((e) => _ctx.closeOtherMultiSelect(e, false), ["self"])),
      class: "data-product"
    }, [
      _hoisted_2,
      _withDirectives(_createElementVNode("select", {
        style: {"width":"auto","font-weight":"700"},
        class: _normalizeClass(["search-select", _ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light']),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataProductSelected) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProductsTypes, (product) => {
          return (_openBlock(), _createElementBlock("option", {
            style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
            key: product,
            value: product.value?.value
          }, _toDisplayString(product.value.label), 13, _hoisted_3))
        }), 128))
      ], 2), [
        [_vModelSelect, _ctx.dataProductSelected]
      ])
    ]),
    _createElementVNode("div", {
      onClick: _cache[8] || (_cache[8] = _withModifiers((e) => _ctx.closeOtherMultiSelect(e, false), ["self"])),
      class: "product-form"
    }, [
      _withDirectives(_createElementVNode("select", {
        class: _normalizeClass(["search-select domain", _ctx.settingsStore.colorScheme]),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDomain) = $event))
      }, [
        _createElementVNode("option", {
          style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
          selected: "",
          value: null
        }, " Select a domain * ", 4),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domains.domains, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
            key: option,
            value: option.id
          }, _toDisplayString(option.id.split(":Domain:")[1]), 13, _hoisted_4))
        }), 128))
      ], 2), [
        [_vModelSelect, _ctx.selectedDomain]
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['name', 'description'], (field, index) => {
        return _createElementVNode("div", {
          key: field,
          class: _normalizeClass(field)
        }, [
          (field === 'name')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                tabindex: index,
                class: _normalizeClass([_ctx.settingsStore.colorScheme, "search-input"]),
                placeholder: `${_ctx.newDataProduct[field].label} ${_ctx.newDataProduct[field].required? '*' : ''}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.newDataProduct[field].value) = $event),
                type: "text"
              }, null, 10, _hoisted_5)), [
                [_vModelText, _ctx.newDataProduct[field].value]
              ])
            : _createCommentVNode("", true),
          (field === 'description')
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 1,
                style: {"height":"100%","resize":"none","background-color":"transparent"},
                class: _normalizeClass([_ctx.settingsStore.colorScheme, "search-input"]),
                placeholder: `${_ctx.newDataProduct[field].label} ${_ctx.newDataProduct[field].required? '*' : ''}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.newDataProduct[field].value) = $event)
              }, null, 10, _hoisted_6)), [
                [_vModelText, _ctx.newDataProduct[field].value]
              ])
            : _createCommentVNode("", true)
        ], 2)
      }), 64)),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['owner', 'glossary'], (field, index) => {
        return _createElementVNode("div", {
          key: field,
          class: _normalizeClass(field)
        }, [
          (field === 'owner')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                tabindex: index,
                class: _normalizeClass(["search-select", _ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light']),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newDataProduct.owner.value) = $event))
              }, [
                _createElementVNode("option", {
                  style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                  selected: "",
                  value: null
                }, " Owner * ", 4),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDataProduct.owner.options, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                    key: option,
                    value: option
                  }, _toDisplayString(option), 13, _hoisted_8))
                }), 128))
              ], 10, _hoisted_7)), [
                [_vModelSelect, _ctx.newDataProduct.owner.value]
              ])
            : _createCommentVNode("", true)
        ], 2)
      }), 64)),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDataProduct.glossary.value, (glossary, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "chip",
            key: glossary.label
          }, [
            _createElementVNode("p", null, _toDisplayString(glossary), 1),
            _createElementVNode("i", {
              onClick: ($event: any) => (_ctx.deleteChipGlossary(i))
            }, [
              _createVNode(_component_font_awesome_icon, {
                style: {"font-size":"16px","display":"flex"},
                icon: "xmark"
              })
            ], 8, _hoisted_10)
          ]))
        }), 128)),
        _withDirectives(_createElementVNode("input", {
          placeholder: "Glossary Terms (press Enter)",
          class: _normalizeClass(_ctx.settingsStore?.colorScheme),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentGlossaryInput) = $event)),
          onKeypress: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveChipGlossary && _ctx.saveChipGlossary(...args)), ["enter"]))
        }, null, 34), [
          [_vModelText, _ctx.currentGlossaryInput]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDataProduct.tags.value, (tag, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "chip",
            key: tag.label
          }, [
            _createTextVNode(_toDisplayString(tag) + " ", 1),
            _createElementVNode("i", {
              onClick: ($event: any) => (_ctx.deleteChip(i))
            }, [
              _createVNode(_component_font_awesome_icon, {
                style: {"font-size":"16px","display":"flex"},
                icon: "xmark"
              })
            ], 8, _hoisted_12)
          ]))
        }), 128)),
        _withDirectives(_createElementVNode("input", {
          placeholder: "Tags (press Enter)",
          class: _normalizeClass(_ctx.settingsStore?.colorScheme),
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentTagInput) = $event)),
          onKeypress: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveChip && _ctx.saveChip(...args)), ["enter"]))
        }, null, 34), [
          [_vModelText, _ctx.currentTagInput]
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.newDataProduct[_ctx.dataProductSelected]), (form) => {
        return (_openBlock(), _createElementBlock("div", { key: form }, [
          (_ctx.newDataProduct[_ctx.dataProductSelected][form].type === 'select')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                tabindex: _ctx.index,
                class: _normalizeClass(["search-select", _ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light']),
                "onUpdate:modelValue": ($event: any) => ((_ctx.newDataProduct[_ctx.dataProductSelected][form].value) = $event)
              }, [
                _createElementVNode("option", {
                  style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                  selected: "",
                  value: null
                }, _toDisplayString(_ctx.newDataProduct[_ctx.dataProductSelected][form].label) + " * ", 5),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDataProduct[_ctx.dataProductSelected][form].options, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                    key: option,
                    value: option
                  }, _toDisplayString(option), 13, _hoisted_14))
                }), 128))
              ], 10, _hoisted_13)), [
                [_vModelSelect, _ctx.newDataProduct[_ctx.dataProductSelected][form].value]
              ])
            : _createCommentVNode("", true),
          (_ctx.newDataProduct[_ctx.dataProductSelected][form].type === 'text')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                class: _normalizeClass([_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light', "search-input"]),
                placeholder: `${_ctx.newDataProduct[_ctx.dataProductSelected][form].label} ${_ctx.newDataProduct[_ctx.dataProductSelected][form].required ? '*' : ''}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.newDataProduct[_ctx.dataProductSelected][form].value) = $event),
                type: "text"
              }, null, 10, _hoisted_15)), [
                [_vModelText, _ctx.newDataProduct[_ctx.dataProductSelected][form].value]
              ])
            : _createCommentVNode("", true),
          (_ctx.newDataProduct[_ctx.dataProductSelected][form].type === 'file')
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                style: {"background":"transparent"},
                class: _normalizeClass([_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light', "search-input file"])
              }, [
                _createElementVNode("label", { for: form }, [
                  _createTextVNode(_toDisplayString(_ctx.newDataProduct[_ctx.dataProductSelected][form]?.value?.item(0)?.name || _ctx.newDataProduct[_ctx.dataProductSelected][form].label) + " " + _toDisplayString(_ctx.newDataProduct[_ctx.dataProductSelected][form].required && !_ctx.newDataProduct[_ctx.dataProductSelected][form]?.value?.item(0)?.name ? '*' : '') + " ", 1),
                  (!_ctx.newDataProduct[_ctx.dataProductSelected][form]?.value)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fa', 'upload']
                      }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_16),
                _createElementVNode("input", {
                  name: form,
                  id: form,
                  accept: _ctx.newDataProduct[_ctx.dataProductSelected][form].accept,
                  onChange: (e) => _ctx.newDataProduct[_ctx.dataProductSelected][form].value = e.target?.files,
                  placeholder: `${_ctx.newDataProduct[_ctx.dataProductSelected][form].label} ${_ctx.newDataProduct[_ctx.dataProductSelected][form].required ? '*' : ''}`,
                  type: "file"
                }, null, 40, _hoisted_17)
              ], 2))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('back'))),
        class: "confirm"
      }, "Back"),
      _createElementVNode("button", {
        disabled: _ctx.checkForm(),
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirm())),
        class: "cancel"
      }, "Save ", 8, _hoisted_19)
    ])
  ], 64))
}